export default __webpack_public_path__ + "static/media/ivypresto_headline_thin-webfont.09da3382.woff2";